"use client";
import { Button } from "@/components/bnp-ui";
import { useLocation } from "@/contexts/LocationContext";

const LocationRequest = () => {
  const { showLocationPrompt, handleRequestLocation } = useLocation();

  if (!showLocationPrompt) return null;

  return (
    <div className="items-center justify-center mb-6 p-4 bg-soft-100 rounded-lg">
      <p className="text-grey-7 mb-3 text-center">
        Enable location access to see properties near you
      </p>
      <Button
        className="bg-bnp-cyan text-white text-sm font-medium w-[197px] h-[45px] rounded-lg"
        onClick={handleRequestLocation}
      >
        Use my location
      </Button>
    </div>
  );
};

export default LocationRequest;
